// src/utils/StatusMonitor.js
class StatusMonitor {
  constructor() {
    this.status = 'healthy';
    this.listeners = [];
    this.history = [];
    this.maxHistory = 100;
    this.metrics = {
      lastSyncAttempt: null,
      lastSuccessfulSync: null,
      consecutiveFailures: 0,
      unsyncedCount: 0,
      pendingRecords: 0
    };
  }

  setStatus(newStatus, metadata = {}) {
    const previousStatus = this.status;
    this.status = newStatus;
    
    // Update metrics
    if (metadata.syncAttempt) {
      this.metrics.lastSyncAttempt = new Date().toISOString();
    }
    if (newStatus === 'healthy' && metadata.syncSuccess) {
      this.metrics.lastSuccessfulSync = new Date().toISOString();
      this.metrics.consecutiveFailures = 0;
    }
    if (metadata.failed) {
      this.metrics.consecutiveFailures++;
    }
    if (metadata.unsyncedCount !== undefined) {
      this.metrics.unsyncedCount = metadata.unsyncedCount;
    }

    this.history.push({
      from: previousStatus,
      to: newStatus,
      timestamp: new Date().toISOString(),
      metadata: {
        ...metadata,
        metrics: { ...this.metrics }
      }
    });

    if (this.history.length > this.maxHistory) {
      this.history.shift();
    }

    this.notifyListeners(newStatus, this.metrics);
    this.persistHistory();
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  }

  notifyListeners(status, metrics) {
    this.listeners.forEach(callback => callback(status, metrics));
  }

  getStatus() {
    return this.status;
  }

  getMetrics() {
    return this.metrics;
  }

  async persistHistory() {
    try {
      localStorage.setItem('statusHistory', JSON.stringify(this.history.slice(-50)));
    } catch (error) {
      console.error('Failed to persist status history:', error);
    }
  }

  async getHistory() {
    try {
      const stored = localStorage.getItem('statusHistory');
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Failed to get status history:', error);
      return [];
    }
  }
}

export const statusMonitor = new StatusMonitor();